import { render, staticRenderFns } from "./MedicalTourismEnglish.vue?vue&type=template&id=83d625e4"
import script from "./MedicalTourismEnglish.vue?vue&type=script&lang=js"
export * from "./MedicalTourismEnglish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports